var _path, _path2, _path3, _path4, _rect, _g, _path5, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcavator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6,7c0.4-0.4,0.4-1.1,0-1.5l0,0c-0.4-0.4-1.1-0.4-1.5,0l-6.1,6c-0.4,0.4-0.4,1.1,0,1.5l0,0 c0.4,0.4,1.1,0.4,1.5,0L19.6,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 11.1,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -3.8878 13.4855)",
    style: {
      fill: "#000"
    },
    width: 4.7,
    height: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "15.7,9.5 16,9.8 19.2,6.6 18.8,6.3  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3,6.3c0-0.6-0.4-1-1-1l0,0c-0.6,0-1,0.4-1,1v7.1c0,0.6,0.4,1,1,1l0,0c0.6,0,1,1.3,1,0.7V6.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7.1,
    style: {
      fill: "#000"
    },
    width: 0.6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 12.1,
    style: {
      fill: "#000"
    },
    width: 0.4,
    height: 1.9
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,7.3c0.6,0,1-0.4,1-1l0,0c0-0.6-0.4-1-1-1h-2.4c-0.6,0-1,0.4-1,1l0,0c0,0.6,0.4,1,1,1H21.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.2,5.8c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5S21.4,5.8,21.2,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.9,5.8c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S19.2,5.8,18.9,5.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 7.3,
    style: {
      fill: "#000"
    },
    width: 4.7,
    height: 5.8
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,7.3v1.5v3v0.9h0.4v-0.8l1.5,0.4v0.4H10v-0.3v-1.4V10h2.9v1.4h0.4V10V9.7V7.3l0,0V6.9H7.7V7.3L7.7,7.3z  M12.9,9.7h-1.4V7.3h1.4V9.7z M10,9.8V7.3h1.2v2.4H10z M8.1,9.1V7.3h1.5v3.2L8.1,9.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 14,
    style: {
      fill: "#000"
    },
    width: 4.8,
    height: 0.8
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 13.2,
    width: 11.4,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "6.1,9.2 6.8,10 1.8,10 1.8,9.2  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.2,6.9c0-0.4,0.3-0.7,0.7-0.7H13c0.4,0,0.7,0.3,0.7,0.7H7.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8,16.8c0,0.6,0.5,1.1,1.1,1.1h12.2c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H2.9 C2.3,15.7,1.8,16.2,1.8,16.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M0.9,16.8c0,1.1,0.9,2,2,2h12.2c1.1,0,2-0.9,2-2s-0.9-2-2-2H2.9C1.8,14.8,0.9,15.7,0.9,16.8z M1.8,16.8 c0-0.6,0.5-1.1,1.1-1.1h12.2c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H2.9C2.3,17.9,1.8,17.4,1.8,16.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15,16.1c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7C14.3,16.4,14.6,16.1,15,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.9,16.1c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7C2.2,16.4,2.5,16.1,2.9,16.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.8,10 1.8,13.2 7.7,13.2 13.2,13.2 13.2,12.6 13.2,11.3 12.5,11.3 12.5,12.6 10.4,12.6 7.7,10  7.7,10  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.2,16.1h2.7c0-1.5-1.2-2.7-2.7-2.7V16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.2,16.1v2.7c1.5,0,2.7-1.2,2.7-2.7H20.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.2,14.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5S21.4,14.4,21.2,14.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    x: 4.3,
    y: 16.5,
    width: 9.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 10.4,
    style: {
      fill: "#000"
    },
    width: 1.8,
    height: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcavator);
export default __webpack_public_path__ + "static/media/excavator.e38575eb336a2dcf79eff73ae85c1db0.svg";
export { ForwardRef as ReactComponent };